import { render, staticRenderFns } from "./ticket-list.vue?vue&type=template&id=3a3ce778"
import script from "./ticket-list.vue?vue&type=script&lang=js"
export * from "./ticket-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports